import React from "react";
import { Box, Button, Chip, Divider, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ListChatTicket } from "../../services/ticket/ticket";
import { convertToJalali } from "../../utils/convertToJalali";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
function SupportCard({ title, comment, status, idstrticket, datesabt }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isRTL = i18next.language === "fa"; // or whatever languages are RTL in your app
  const { i18n } = useTranslation();
  const direction = i18n.dir(); // 'rtl' or 'ltr'

  // Translate status if not Persian
  let displayStatus = status;
  if (i18n.language !== 'fa') {
    if (status === "در انتظار پاسخ") displayStatus = "Pending";
    else if (status === "پاسخ داده شده") displayStatus = "Answered";
    else if (status === "بسته شده") displayStatus = "Closed";
  }

  const handleView = async () => {
    try {
      const response = await ListChatTicket(idstrticket); // API call

      if (response.status === 200) {
        // Navigate to the specific page after successful API call
        navigate(`/support/${idstrticket}`, {
          state: { title, status },
        });
      } else {
        throw new Error("Invalid Response"); // Handle any invalid response
      }
    } catch (err) {
      // Show a popup in case of an error
      Swal.fire({
        title: "خطا در دریافت اطلاعات",
        confirmButtonText: "باشه",
      });
    }
  };
  return (
    <>
      <Box className="border-[1px] border-purple rounded-md p-4 my-4" dir={direction}>
        <Box className="flex justify-between items-start  gap-y-2">
          <Box className="flex items-center gap-1  justify-between w-full">
            <Typography variant="body2">{convertToJalali(datesabt)}</Typography>

            <Chip
              label={displayStatus}
              color={
                status === "در انتظار پاسخ"
                  ? "warning"
                  : status === "پاسخ داده شده"
                  ? "success"
                  : status === "بسته شده"
                  ? "default"
                  : "default"
              }
              variant="filled"
            />
          </Box>
        </Box>
        <Divider sx={{ my: 1, bgcolor: "grey.500" }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography className=" sm:w-auto " variant="h6">
            {title}
          </Typography>
          <Typography
            variant="body1"
            className="mt-3 "
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {comment}
          </Typography>
        </Box>

        <Box className="flex justify-end mt-4">
          <Button
            sx={{ textTransform: "none" }}
            color="primary"
            endIcon={isRTL ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            onClick={handleView}
          >
            {t("Support.View")}
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default SupportCard;
